




















import { Vue, Component, Prop, Emit } from "vue-property-decorator";
import { ElementMenuItem } from "@/models/elementMenuItem.ts";
import {
  PresetMenuItem,
  presets,
  PresetType,
  PresetStep,
} from "@/models/presets";
import { Vector2 } from "@babylonjs/core";
import { ElementType, SpecyficType } from "@/models/element";
import { base64Warehouse } from "@/models/base64warehouse";
import store from "@/store";
import AvatarComponent from "@/components/AvatarComponent.vue";
import ZoomAvatarComponent from "@/components/ZoomAvatarComponent.vue";

@Component({
  components: {
    AvatarComponent,
    ZoomAvatarComponent,
  },
})
export default class ComponentsListItem extends Vue {
  @Prop({ type: Array, required: true }) elements!: ElementMenuItem[];
}
